var aws_exports = {
    "REGION": "us-east-1",
    "USER_POOL_ID": "us-east-1_SXKXJyMgG",
    "USER_POOL_APP_CLIENT_ID": "247m5qkotpdefkfpq0abssc9s7",
}

export default aws_exports